import { Guid, Nillable } from '@web/utils';
import { AdminCosmeticStatus } from '../enums';
import { Multimedia } from '@web/shared/module/multimedia';
import { AdminCosmeticCharacteristicDetails } from './admin-cosmetic-characteristic-details';
import { AdminCosmeticAttributeDetails } from './admin-cosmetic-attribute-details';

export class AdminCosmeticDetails {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      cosmeticBrandId?: Nillable<Guid>;
      cosmeticBrandName?: Nillable<string>;
      characteristics?: Nillable<AdminCosmeticCharacteristicDetails[]>;
      attributes?: Nillable<AdminCosmeticAttributeDetails[]>;
      createdAt: Date;
      featuredFile?: Nillable<Multimedia>;
      files: Multimedia[];
      id: Guid;
      name: string;
      price?: Nillable<number>;
      slug: string;
      status: AdminCosmeticStatus;
      vendorUrl?: Nillable<string>;
      warehouseProductName?: Nillable<string>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get cosmeticBrandId(): Nillable<Guid> {
    return this.data.cosmeticBrandId;
  }

  public get cosmeticBrandName(): Nillable<string> {
    return this.data.cosmeticBrandName;
  }

  /* prettier-ignore */
  public get characteristics(): Nillable<AdminCosmeticCharacteristicDetails[]> {
    return this.data.characteristics;
  }

  public get attributes(): Nillable<AdminCosmeticAttributeDetails[]> {
    return this.data.attributes;
  }

  public get featuredFile(): Nillable<Multimedia> {
    return this.data.featuredFile;
  }

  public get price(): Nillable<number> {
    return this.data.price;
  }

  public get status(): AdminCosmeticStatus {
    return this.data.status;
  }

  public get vendorUrl(): Nillable<string> {
    return this.data.vendorUrl;
  }

  public get warehouseProductName(): Nillable<string> {
    return this.data.warehouseProductName;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }

  public get files(): Multimedia[] {
    return this.data.files;
  }
}
